<template>
    <div>
        <rkm-overlay>
            <rkm-layout-body title="Lançamento de resultado">
                <template v-slot:actions>

                    <rkm-button
                        @click.stop="handleExit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        @click.stop="$refs.Modal.open()"
                        color="secondary"
                    >
                        Histórico
                    </rkm-button>

                    <rkm-button
                        v-if="!exameAgrupado && showButton"
                        @click="$refs.Form.savePrint()"
                        color="info"
                    >
                        Salvar e imprimir
                    </rkm-button>

                    <rkm-button
                        v-if="exameAgrupado && showButton"
                        @click="$refs.Form.printResultadoAgrupado()"
                        color="info"
                    >
                        Salvar e imprimir
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <Form
                        :id="id"
                        @save="handleSaveExit"
                        @print="print"
                        @printResultadoAgrupado="printResultadoAgrupado"
                        @agrupado="agrupado"
                        @handleShowButton="handleShowButton"
                        @handleHistorico="handleHistorico"
                        ref="Form"
                    />
                </rkm-layout-content>
            </rkm-layout-body>
        </rkm-overlay>

        <Modal
            ref="Modal"
            :items="historico"
        />
    </div>
</template>

<script>
import Form from '@/components/exame-laboratorial/lancamento-resultado/Form'
import Modal from '@/components/exame-laboratorial/lancamento-resultado/Modal'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form, Modal },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial')
        }
    },
    data: () => ({
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
        exameAgrupado: false,
        showButton: true,
        historico: []
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        handleSaveExit() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList();
        },
        redirectToList() {

            this.$router.push({ name: 'exame-laboratorial-lancamento-resultado-index' })
        },
        agrupado(agrupado) {

            this.exameAgrupado = agrupado
        },
        handleShowButton(show) {

            this.showButton = show
        },
        handleHistorico(historico) {

            this.historico = historico
        },
        print() {

            this.repositories.impressao.exameResultado(this.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() =>
                        this.showSaveNotification(),
                        this.unsetShowExitFormConfirmation(),
                        this.redirectToList()
                    )
        },
        printResultadoAgrupado() {

            this.repositories.impressao.exameResultadoAgrupado(this.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                    .catch(this.handleError)
                    .finally(() =>
                        this.showSaveNotification(),
                        this.unsetShowExitFormConfirmation(),
                        this.redirectToList()
                    )
        },
    },
    mixins: [repository, error, object, data],
    props: {
        id: { type: Number, default: null }
    },
}
</script>